import styled from "styled-components";

export const Container = styled.div``;
export const Wrapper = styled.div`
  max-width: 1184px;
  margin: 0 auto;
`;